// Centralized Amplify imports.
// webpack's DefinePlugin makes process.env.MYTMPVPN_USEMOCKS resolvable at bundle time,
// allowing tree-shaking to remove the unused branch (mocks or real libs).

import { Logger } from '@mytmpvpn/mytmpvpn-common/logger'

// Always import both; webpack will eliminate unused code based on DefinePlugin.
import * as realUiReact from '@aws-amplify/ui-react'
import * as mockUiReact from './__mocks__/aws-amplify-ui-react.tsx'
import * as realAuth from '@aws-amplify/auth'
import * as mockAuth from './__mocks__/aws-amplify-auth.tsx'

const logger = Logger.create('amplify')
const isMock = process.env.MYTMPVPN_USEMOCKS === 'true'

// Select which modules to use
const uiReact = isMock ? mockUiReact : realUiReact
const auth = isMock ? mockAuth : realAuth

// Export the selected implementations
export const useAuthenticator = uiReact.useAuthenticator
export const Authenticator = uiReact.Authenticator
export const fetchUserAttributes = auth.fetchUserAttributes
export const getCurrentUser = auth.getCurrentUser
